// Borg agent listing API and React Query definition.
// Property names use snake_case to match the backend response format.
// useNamingConvention is disabled for this file via biome.mjs override.

import { request } from "../../generic/request";
import { borgAgentsResponseSchema } from "../models/borg-schemas";
import type { BorgAgentInfo } from "../models/borg-types";
import { SESSIONS_QUERY_NAMESPACE } from "../query-namespace";

import { borgApiPath } from "./borg-api";

const borgAgentsQueryKey = () => [...SESSIONS_QUERY_NAMESPACE, "list", "agents"] as const;

export const queryBorgAgents = {
	queryKey: borgAgentsQueryKey(),
	queryFn: async (): Promise<ReadonlyArray<BorgAgentInfo>> =>
		borgAgentsResponseSchema.parse(await request(borgApiPath("/agents"))),
	staleTime: 60_000,
};
